import { FC } from "react"
import { SearchInput } from "../SearchInput"
import { SortSelect } from "../SortSelect"
import styles from "./InventoryToolbar.module.scss"
import { IInventoryToolbarProps } from "./types"

export const InventoryToolbar: FC<IInventoryToolbarProps> = ({
  query,
  onQueryChange
}) => (
  <div className={styles.InventoryToolbar}>
    <SearchInput
      value={query.search}
      onChange={(search) => onQueryChange({ ...query, search })}
    />
    <SortSelect
      value={query.sortKey}
      onChange={(sortKey) => onQueryChange({ ...query, sortKey })}
    />
  </div>
)
